import _ from 'lodash';
import apiClient from 'api';
import { getAllowedProperties } from 'api/utils';
import { fetchAllFromMonitorServer } from 'api/common';
import { filterForAllowedProperties, formatControlTypes } from 'utils/format';
import { RESOURCE_TYPES } from 'utils/appConstants';

const monitorApiBaseUrl = window.env.REACT_APP_MONITOR_API_PATH;
const northgateApiBaseUrl = window.env.REACT_APP_NORTHGATE_API_PATH;
const EDIT_PROPERTIES = ['description', 'parentTopoNodeId', 'pollRate'];

export const allowedTopoNodesProperties = [
  'description',
  'childTopoNodeIds',
  'topoNodeId',
  'deviceIds',
  'primacy',
  'pollRate',
  'parentTopoNodeId',
  'localNode'
];

const allowedTopoNodeParams = [
  'id',
  'parentId',
  'devId',
  'start',
  'limit',
  'desc'
];

export const fetchAllTopoNodes = async (queryParams = {}) => {
  const topoNodes = await fetchAllFromMonitorServer(
    RESOURCE_TYPES.TOPONODE,
    allowedTopoNodeParams,
    queryParams
  );
  return topoNodes.map(topoNode =>
    filterForAllowedProperties(topoNode, allowedTopoNodesProperties)
  );
};

export const fetchTopoNodeById = async id => {
  const [topoNode] = await fetchAllTopoNodes({ id });
  return topoNode;
};

export const edit = async topoNode => {
  let updatedTopoNodeData = getAllowedProperties(topoNode, EDIT_PROPERTIES);
  const filteredPayload = _.omitBy(
    updatedTopoNodeData,
    value => value === null || value === ''
  );
  await apiClient.put(
    northgateApiBaseUrl,
    `/toponode/${topoNode.topoNodeId}`,
    filteredPayload
  );
  return updatedTopoNodeData;
};

export const remove = async topoNodeId => {
  return await apiClient.delete(
    northgateApiBaseUrl,
    `/toponode/${topoNodeId}?deleteChildNodes=true`
  );
};

export const create = async newTopoNode => {
  const filteredPayload = _.omitBy(
    newTopoNode,
    value => value === null || value === ''
  );
  return await apiClient.post(
    northgateApiBaseUrl,
    `/toponode`,
    filteredPayload
  );
};

export const fetchTopoNodeDefaultControl = async topoNodeId => {
  const defaultControl = await apiClient.get(
    monitorApiBaseUrl,
    `/toponode/${topoNodeId}/default`
  );
  return formatControlTypes(defaultControl);
};

export const updateDefaultControl = async (nodeId, control) => {
  const filteredPayload = _.omitBy(
    control,
    value => value === null || value === '' || _.isNaN(value)
  );
  return await apiClient.put(
    northgateApiBaseUrl,
    `/toponode/${nodeId}/default`,
    filteredPayload
  );
};
